import React from 'react';

import { Stack, Text } from '@atlaskit/primitives/compiled';

import { useDynamicString } from '../../hooks/useDynamicValue.tsx';
import type { A2UIComponentDefinition } from '../../types/A2UIComponents.types.tsx';
import type { A2UIAudioPlayerProps } from '../../types/A2UIComponents.types.tsx';

type Props = {
	definition: A2UIComponentDefinition;
};

export const A2UIAudioPlayer = ({ definition }: Props): React.JSX.Element => {
	const def = definition as A2UIAudioPlayerProps;
	const url = useDynamicString(def.url);
	const description = useDynamicString(def.description);
	const label = def.accessibility?.label ?? '';

	return (
		<Stack space="space.100">
			{description && <Text as="span">{description}</Text>}
			{/* eslint-disable-next-line jsx-a11y/media-has-caption */}
			<audio src={url} controls aria-label={label} />
		</Stack>
	);
};
